import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Price as Price$1 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const ariaLabelKeys = {
    full: undefined,
    new: 'common.discountedPrice',
    old: 'common.originalPrice'
};
var Price = (_param)=>{
    var { 'aria-label': ariaLabel , 'data-t': dataT , hasFixedDecimals =false , isCentAmount =false , size , type ='full' , value  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        'aria-label',
        'data-t',
        "hasFixedDecimals",
        "isCentAmount",
        "size",
        "type",
        "value"
    ]);
    const { locale , getLabel , currency  } = useIntl();
    const ariaLabelKey = ariaLabelKeys[type];
    const defaultAriaLabel = ariaLabelKey ? getLabel(ariaLabelKey) : undefined;
    const ariaLabelValue = ariaLabel || defaultAriaLabel;
    const formattedPrice = formatPrice({
        locale,
        value,
        currency,
        isCentAmount,
        fixedDecimals: hasFixedDecimals
    });
    return /*#__PURE__*/ React.createElement(Price$1, swcHelpers.extends({
        "aria-label": ariaLabelValue,
        "data-t": dataT,
        type: type,
        size: size
    }, rest), formattedPrice);
};

export { Price };
//# sourceMappingURL=Price.js.map
